import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';


// OTHER MODULE IMPORTS

import { SharedModule } from './../../shared.module';
import { MaterialsModule } from './../../materials.module';
import { MainSchedulerRoutingModule } from './main-scheduler-routing.module';


// IMPORT SCHEDULER MODULE COMPONENTS


import { MainSchedulerComponent } from './main-scheduler.component';
import { SchedulerComponent } from '../scheduler.component';
import { JobDayComponent } from '../new-schedular/job/job-day.component';
import { NewSchedularComponent } from '../new-schedular/new-schedular.component';
import { InstructorWeekComponent } from '../new-schedular/instructor-week/instructor-week.component';
import { DateDayComponent } from '../new-schedular/date-day/date-day.component';
import { JobDetailsComponent } from '../new-schedular/job-details/job-details.component';


@NgModule({
  declarations: [
    MainSchedulerComponent,
    SchedulerComponent,
    JobDayComponent,
    NewSchedularComponent,
    InstructorWeekComponent,
    DateDayComponent,
    JobDetailsComponent,
  ],
  imports: [
    CommonModule,
    MainSchedulerRoutingModule,
    SharedModule,
    MaterialsModule,
  ],
  entryComponents: [SchedulerComponent , JobDetailsComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MainSchedulerModule { }
